// Func = limiting Scope for this file
var lastScrollTop = 0;

//parallax variables
var scrollParallaxH = [];
var lastScrollLeft = [];


//booking dates
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


function convertBtn() {
	if(document.getElementsByClassName('btn').length > 0){
		let allBtn = document.getElementsByClassName('btn');
		for(let btn of allBtn){
			let innerT = btn.innerHTML;
			btn.innerHTML = '<span>' + innerT + '</span>';
		}
	}
}


(function(){

	window.addEventListener("popstate", () => {
		localStorage.setItem("hasVisit", "no");
	})

	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
		speed: 2000,
	});
	$('.slider-background').slick({
		dots: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		arrows: true,
		adaptiveHeight: true
	});

	$('.benefits-slides').slick({
		slidesToShow:3,
		centerMode: true,
		speed: 2000,
		centerPadding: '0',
		autoplay:true,
		autoplaySpeed:5000,
		accessibility:true
	});


	$('.main-slides').slick({
		fade:true,
		arrows:false,
		speed: 1000,
		autoplay:true,
		autoplaySpeed:4000,
		accessibility:false,
		asNavFor:'.sec-slides'
		
	})
	$('.sec-slides').slick({
		asNavFor:'.main-slides',
		slidesToShow:3,
		accessibility:false,
		speed: 1000,
		centerMode:true,
		centerPadding:0
	})


	// Multiple Slider
	$('.multiple-slider').slick({
		accessibility:false,
		arrows:false,
		speed: 500,
		dots:true,
		fade:true 
	})
	if(document.getElementsByClassName('js-slider-image').length > 0){
		let allImagesSlider = document.getElementsByClassName('js-slider-image');
		for(let image of allImagesSlider){
			image.addEventListener('click', function(){
				let targetElement = this.getAttribute('data-index');
				for(let i of allImagesSlider){
					if(i == this){
						this.classList.add('active')
					} else {
						i.classList.remove('active')
					}
				}
				$('.multiple-slider').slick('slickGoTo',targetElement);
			})
		}
		$('.multiple-slider').on('afterChange', function(event, slick, currentSlide){
			for(let image of allImagesSlider){
				if(image == allImagesSlider[currentSlide]){
					image.classList.add('active')
				} else {
					image.classList.remove('active')
				}
			}
		});
	}
	

	//Add span in every btn
	if(document.getElementById('attractions')){
		setTimeout(() => {
			convertBtn();
		}, 1200);
	} else {
		convertBtn();
	}

	//Menu Container clicks
	if(document.getElementById('burgerMenu')){
		document.getElementById('burgerMenu').addEventListener('click', function(e){
			e.preventDefault();
			document.getElementById('menuContainer').classList.add('open')
		})
	}
	
	if(document.getElementsByClassName('js-container-close').length > 0){
		let allCloses = document.getElementsByClassName('js-container-close');
		for(let a of allCloses){
			let link = a.getElementsByTagName('a')[0];
			link.addEventListener('click', function(e){
				e.preventDefault();
				let target = this.getAttribute('href').split('#')[1];
				document.getElementById(target).classList.remove('open')
			})
		}
		
	}
	//Booking Container clicks
	document.getElementById('bookingCta').addEventListener('click', function(e){
		e.preventDefault();
		document.getElementById('bookingContainer').classList.add('open')
	})


	//forms animation focus
	if(document.getElementsByClassName('js-field').length > 0){
		let bookingFields = document.getElementsByClassName('js-field');
		for(let field of bookingFields){
			if(field.getElementsByTagName('input').length > 0){
				if(field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
					field.getElementsByTagName('input')[0].addEventListener('focus', function(){
						this.parentElement.classList.add('moved');
					})
				}
			}
			if(field.getElementsByTagName('select').length > 0){
				field.getElementsByTagName('select')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
		}
	}

	//email signup animation 
	if(document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}
	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.parentElement.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
	   }
	}
	//parallax
	if(document.getElementsByClassName('parallax-image').length > 0){
		if(window.innerWidth > 1090 ){
			let horizontalOptions = {
				root : null,
				rootMargin : '0px',
				threshold : 0.1
			}
			function handlerParallaxH(entries, observer){
				for(let entry of entries){
					if (entry.isIntersecting) {
						parallaxEffectH(entry.target);
					} else {
						let id_elem = entry.target.getAttribute('parallax-id');
						window.addEventListener('scroll', scrollParallaxH[id_elem])
					}
				}
			}
			let allParallax = document.getElementsByClassName('parallax-image');
			for(let  j = 0; j < allParallax.length; j++ ){
				let observerP = new IntersectionObserver(handlerParallaxH, horizontalOptions)
				observerP.observe(allParallax[j]);
			}

		}
	}
	//parallax
	if(document.getElementsByClassName('parallax-object').length > 0){
		if(window.innerWidth > 1090 ){
			let horizontalOptionsO = {
				root : null,
				rootMargin : '0px',
				threshold : 0.1
			}
			function handlerParallaxO(entries, observer){
				for(let entry of entries){
					if (entry.isIntersecting) {
						parallaxEffectO(entry.target);
					} else {
						let id_elem = entry.target.getAttribute('parallax-id');
						window.addEventListener('scroll', scrollParallaxH[id_elem])
					}
				}
			}
			let allParallaxO = document.getElementsByClassName('parallax-object');
			for(let  j = 0; j < allParallaxO.length; j++ ){
				let observerP = new IntersectionObserver(handlerParallaxO, horizontalOptionsO)
				observerP.observe(allParallaxO[j]);
			}

		}
	}


	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
				
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}






	$(document).ready(function () {


		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		
		
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					$('#arriveInput').parent().addClass('moved')
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}	
					$('#departureInput').parent().addClass('moved')
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			}
		});	
		//booking input change
		document.getElementById('arriveInput').addEventListener('change', function(){
			start = this.value;
			$('#bookingCalendar').datepicker("setDate", start)
			$('#bookingCalendar').datepicker("setDate", end)
		});
		document.getElementById('departureInput').addEventListener('change', function(){
			end = this.value;
			$('#bookingCalendar').datepicker("setDate", start)
			$('#bookingCalendar').datepicker("setDate", end)
		});
	});

	


	window.onload = function() {
		if(document.getElementById('attractions') || document.getElementById('gallery') || document.getElementsByClassName('sitemap').length > 0){
			document.getElementById('header').classList.add('down');
		} else {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		// preload video this video only play one time with the next validation
		// if(sessionStorage.getItem("hasVisit") !== "yes"){
		// 	const asideVideo = document.getElementById("preload-video");
		// 	const videoPreload = document.getElementById("preload");
		// 	const topContent = document.getElementsByClassName('top-content')[0];
		// 	const homeVideo = document.getElementById('homeVideo');
		// 	homeVideo.pause();
		// 	topContent.classList.add('no-show');
		// 	if(asideVideo){
				
		// 		asideVideo.classList.remove("no-show");
		// 		videoPreload.play();
		// 		videoPreload.addEventListener("timeupdate",function(){
		// 			const { duration, currentTime } = videoPreload;
		// 			if(duration <= currentTime){
		// 				asideVideo.classList.add("no-show");
		// 				//only play one time
		// 				sessionStorage.setItem("hasVisit", "yes");

		// 				topContent.classList.remove('no-show');
		// 				homeVideo.play();
		// 			};
		// 		});
		// 	}
		// } else {
		// 	document.getElementsByClassName('top-content')[0].classList.remove('no-show')
		// }
	};

}());

function liveTextMenusDisplayed(){

	let allContainersOfMenus = document.querySelectorAll('.jsLiveTextMenusInner');
	if( !allContainersOfMenus )
		return;
        
	allContainersOfMenus.forEach( (innerLiveTextMenu, index) => {

		let listContainer = innerLiveTextMenu.querySelector('.js-menus-list');
		listContainer.setAttribute('data-indexOfInnerElement', index);
		let title = innerLiveTextMenu.dataset.titlemenu;
		
		/*
		* --- OPEN --- FUNTIONALITY FOR MENUS SHORTCODE FILTER DESKTOP ---
		*/
			if( innerLiveTextMenu.querySelector('.jsMenusFilter') ){
				let allFilters = innerLiveTextMenu.querySelectorAll('.jsMenusFilter li');
				let allFiltersLength = allFilters.length;
				let menuId = allFilters[0].getAttribute('data-value');

				loadMenuOfLiveTextMenus(menuId, index, title);

				for( let i =0; i < allFiltersLength; i++){
					allFilters[i].addEventListener('click', function(){
						let currentTarget = this.getAttribute('data-value');
						for(let j =0; j < allFiltersLength; j++){
							if(allFilters[j].getAttribute('data-value') == currentTarget){
								allFilters[j].classList.add('active');
							} else {
								allFilters[j].classList.remove('active');
							}
						}
						loadMenuOfLiveTextMenus(currentTarget, index, title);
					})
				}
			}else{
				let menuId = innerLiveTextMenu.dataset.idmenu;
				loadMenuOfLiveTextMenus(menuId, index, title);
			}
		/*
		* --- CLOSE --- FUNTIONALITY FOR MENUS SHORTCODE FILTER DESKTOP ---
		*/

		/*
		* --- OPEN --- FUNTIONALITY FOR MENUS SHORTCODE FILTER MOBILE ---
		*/
			if(innerLiveTextMenu.querySelector('.jsMenusSelect')){
				let allFilter = innerLiveTextMenu.querySelector('.jsMenusSelect');
				let menuId = allFilter.value;

				loadMenuOfLiveTextMenus(menuId, index, title);
				
				allFilter.addEventListener('change', function(){
					let menuId = allFilter.value;
					loadMenuOfLiveTextMenus(menuId, index, title);
				})

				
			}
		/*
		* --- CLOSE --- FUNTIONALITY FOR MENUS SHORTCODE FILTER MOBILE ---
		*/
	} );

}

function loadMenuOfLiveTextMenus(menuTarget, numberIdToInnerContent, title){
	console.log(title);
    let currentInnerElement = document.querySelector(`.js-menus-list[data-indexOfInnerElement="${numberIdToInnerContent}"]`);
    currentInnerElement.classList.add('preloaded');
    currentInnerElement.classList.remove('ready');
    try {
        fetch(`${site_url}ajax/functions.php?operation=getMenus&menu=${encodeURIComponent(menuTarget)}&title=${title}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            currentInnerElement.innerHTML = data.html;
            setTimeout(() => {
                currentInnerElement.classList.add('ready');
            }, 500);
        })
        .catch(error => {
            console.error('Fetch error:', error);
        });
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function parallaxEffectH(target){
	let id_elem = target.getAttribute('parallax-id');
	let temp = parseInt(target.getAttribute('data-parallax').split(',')[1]);
	let targetImage = target.getElementsByTagName('img')[0];

	let parallaxFunctionT = function(){
		
		let stp = window.pageYOffset || document.documentElement.scrollTop;

		if(lastScrollLeft[id_elem] === undefined){
			lastScrollLeft[id_elem] = parseInt(stp) - 1;
		}
		
		let direction = target.getAttribute('data-parallax').split(',')[0];
		if (stp > lastScrollLeft[id_elem]){
			
			temp = temp + (direction * 0.5);
			lastScrollLeft[id_elem] = stp - 1;
		} else {
			
			temp = temp - (direction * 0.5);
			lastScrollLeft[id_elem] = stp + 1;
		}
	
			targetImage.setAttribute('style','transform:translateY(' + parseInt(temp) + 'px)');
			target.setAttribute('data-parallax',direction + ',' + parseInt(temp) );

	}
	

	scrollParallaxH[id_elem] = parallaxFunctionT
	window.addEventListener('scroll', scrollParallaxH[id_elem])
}

function parallaxEffectO(target){
	let id_elem = target.getAttribute('parallax-id');
	let temp = parseInt(target.getAttribute('data-parallax').split(',')[1]);

	let parallaxFunctionT = function(){
		
		let stp = window.pageYOffset || document.documentElement.scrollTop;

		if(lastScrollLeft[id_elem] === undefined){
			lastScrollLeft[id_elem] = parseInt(stp) - 1;
		}
		
		let direction = target.getAttribute('data-parallax').split(',')[0];
		if (stp > lastScrollLeft[id_elem]){
			
			temp = temp + (direction * 0.5);
			lastScrollLeft[id_elem] = stp - 1;
		} else {
			
			temp = temp - (direction * 0.5);
			lastScrollLeft[id_elem] = stp + 1;
		}
	
			target.setAttribute('style','transform:translateY(' + parseInt(temp) + 'px)');
			target.setAttribute('data-parallax',direction + ',' + parseInt(temp) );

	}
	

	scrollParallaxH[id_elem] = parallaxFunctionT
	window.addEventListener('scroll', scrollParallaxH[id_elem])
}

document.addEventListener('DOMContentLoaded', function(){
	liveTextMenusDisplayed();
	console.info( 'Document State', document.readyState);
});